import { render, staticRenderFns } from "./AppointmentNotificationEmailedCustomer.vue?vue&type=template&id=728eb9a5"
import script from "./AppointmentNotificationEmailedCustomer.vue?vue&type=script&lang=js"
export * from "./AppointmentNotificationEmailedCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports